import { UIText2 } from '@cian/ui-kit';
import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './Transport.css';
import { TransportIcon, TransportTypes } from '../TransportIcon';

export interface ITransportProps {
  name: string;
  iconColor: string | null | undefined;
  remoteness: string | null | undefined;
  iconType: TransportTypes | null | undefined;
}

export const Transport: React.FC<ITransportProps> = props => {
  const { iconColor, name, remoteness, iconType } = props;

  const remotenessBlock = React.useMemo(() => {
    if (!remoteness) {
      return null;
    }

    const remotenessIcon = remoteness.toLowerCase().includes('пешком') ? (
      <IconMapWalk16 color="gray60_100" />
    ) : (
      <IconMapCar16 color="gray60_100" />
    );

    /**
     * Костыль для сокращения текста, чтобы баннер работал корректно в узкой выдаче
     */
    const remotenessTextShortened = remoteness

      .replace(/минут(ы|у)?/g, 'мин.')
      .replace('пешком', '')
      .replace('на автомобиле', '')
      .replace('на транспорте', '');

    return (
      <div className={styles['text-with-icon']}>
        <div className={styles['icon']}>{remotenessIcon}</div>
        <UIText2 color="gray60_100" display="inline">
          {remotenessTextShortened}
        </UIText2>
      </div>
    );
  }, [remoteness]);

  return (
    <div className={styles['container']} data-testid="metro_block">
      <div className={styles['text-with-icon']}>
        {!!iconColor && !!iconType && (
          <div className={styles['icon']}>
            <TransportIcon iconColor={iconColor} iconType={iconType} />
          </div>
        )}
        <UIText2 display="inline">{name}</UIText2>
      </div>

      {remotenessBlock}
    </div>
  );
};

Transport.displayName = 'Transport';
